import React, { ReactElement } from 'react';

interface IProps {
  name: any;
  url: any;
  size?: 'medium' | 'large';
}

// The small thumbnail that displays within a library card.
export default function LibraryThumbnail({
  name,
  url,
  size = 'medium',
}: IProps): ReactElement {
  return (
    <img
      src={url}
      className="library-thumbnail max-h-20 w-auto max-w-20 rounded-lg border border-neutral-gray-200 object-contain"
      width={size === 'medium' ? 40 : 80}
      height={size === 'medium' ? 40 : 80}
      alt={name}
    />
  );
}
